// API設定ファイル
// 全てのAPI呼び出しで使用するベースURL設定

// 環境変数からベースURLを取得、フォールバックを設定
const getBaseUrl = (): string => {
  // 1. 環境変数から取得を試行
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // 2. 開発環境での自動判定
  if (process.env.NODE_ENV === 'development') {
    // 開発環境ではlocalhost:8000を使用
    return 'http://localhost:8000';
  }

  // 3. プロダクション環境でのデフォルト
  return 'https://api-subscnavi.accord33.org';
};

// APIベースURL（アプリ全体で使用）
export const API_BASE_URL = getBaseUrl();

// エンドポイント定数定義
export const API_ENDPOINTS = {
  // 認証関連
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    ME: '/auth/me',
  },
  
  // サブスクリプション管理
  SUBSCRIPTIONS: {
    LIST: '/subscriptions',
    CREATE: '/subscriptions',
    GET: (id: string | number) => `/subscriptions/${id}`,
    UPDATE: (id: string | number) => `/subscriptions/${id}`,
    DELETE: (id: string | number) => `/subscriptions/${id}`,
    CATEGORIES: '/subscriptions/categories',
  },
  
  // ダッシュボード
  DASHBOARD: {
    SUMMARY: '/dashboard/summary',
    ANALYTICS: '/dashboard/analytics',
    CATEGORIES: '/dashboard/categories',
  },
} as const;

// API設定オブジェクト
export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  TIMEOUT: 10000, // 10秒タイムアウト
  HEADERS: {
    'Content-Type': 'application/json',
  },
} as const;

// APIクライアント用のベースURLを返すヘルパー関数
export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};

// 開発者向けのデバッグ情報
if (process.env.NODE_ENV === 'development') {
  console.log('🔗 API Configuration:', {
    baseUrl: API_BASE_URL,
    environment: process.env.NODE_ENV,
    envVar: process.env.REACT_APP_API_BASE_URL ? 'Set' : 'Not set',
  });
}
